<script lang="ts" setup>
/// <reference types="svgo" />

import type { DefineComponent } from 'vue';

import { getByPathAssets, type SvgNameKeys } from '@/utils/assetsPath';

defineOptions({
    inheritAttrs: false
});

const props = defineProps({
    name: {
        type: String as () => SvgNameKeys,
        required: true
    },
    size: {
        type: Number,
        default: 16
    }
});

const iconList = import.meta.glob('@/assets/images/svg/**/*.svg');
const icon = shallowRef<DefineComponent | null>(null);

watch(
    () => props.name,
    (newName) => {
        const path = getByPathAssets(newName);
        if (path && iconList[`${path}`]) {
            const iconLoader = iconList[`${path}`];
            if (iconLoader) {
                icon.value = defineAsyncComponent(
                    () => iconLoader() as Promise<DefineComponent>
                );
            }
        }
    },
    { immediate: true }
);
</script>
<template>
  <component v-if="icon"
             :is="icon"
             v-bind="$attrs"
             :width="props.size"
             :height="props.size"
             class="fill-current"
  />
  <svg v-else
       :width="props.size"
       :height="props.size"
       v-bind="$attrs"
       viewBox="0 0 16 16"
       xmlns="http://www.w3.org/2000/svg"
       fill="currentColor"
  >
    <path d="M4 1C2.36 1 1 2.36 1 4v1h1V4c0-1.1.9-2 2-2h1V1zm2 0v1h4V1zm5 0v1h1a2 2 0 0 1 2 2v1h1V4c0-1.64-1.36-3-3-3zM6 5a1 1 0 0 0 0 2 1 1 0 0 0 0-2zM1 6v4h1V6zm13 0v4h1V6zM9.5 8l-2 2L6 9l-2 2v.5c0 .5.5.5.5.5h7s.47-.04.5-.5v-1zM1 11v1c0 1.64 1.36 3 3 3h1v-1H4a2 2 0 0 1-2-2v-1zm13 0v1a2 2 0 0 1-2 2h-1v1h1c1.64 0 3-1.36 3-3v-1zm-8 3v1h4v-1zm0 0" />
  </svg>
</template>
